export const DarkBlue = ({
  className,
  accent1,
}: {
  className?: string;
  accent1?: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="288"
    viewBox="0 0 48 288"
    fill="none"
  >
    <g clipPath="url(#clip0_3736_1841)">
      <rect width="48" height="288" fill={accent1} />
      <path d="M0 252L-1.57361e-06 288L34 288" fill="white" />
      <path d="M48 252L48 288L14 288" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_3736_1841">
        <rect width="48" height="288" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
